/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserItemAdminResponsePage } from '../../models/user-item-admin-response-page';

export interface ListUsers$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'firstName' | '-firstName' | 'lastName' | '-lastName' | 'employmentType' | '-employmentType' | 'companyName' | '-companyName' | 'isEnabled' | '-isEnabled' | 'email' | '-email'>;
}

export function listUsers(http: HttpClient, rootUrl: string, params?: ListUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserItemAdminResponsePage>> {
  const rb = new RequestBuilder(rootUrl, listUsers.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {"style":"form"});
    rb.query('limit', params.limit, {"style":"form"});
    rb.query('sorting', params.sorting, {"style":"form"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserItemAdminResponsePage>;
    })
  );
}

listUsers.PATH = '/v0/admin/users';
